import { useState, useCallback } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useRestaurantContext } from "@/contexts/RestaurantContext";
import { toast } from "sonner";

export function useServiceTax() {
  const { activeRestaurant, refetch } = useRestaurantContext();
  const [isUpdating, setIsUpdating] = useState(false);

  const serviceTaxPercentage = Number(
    (activeRestaurant as any)?.service_tax_percentage ?? 10
  );
  const serviceTaxEnabled = Boolean(
    (activeRestaurant as any)?.service_tax_enabled ?? false
  );

  const updateServiceTax = async (percentage: number, enabled: boolean) => {
    if (!activeRestaurant) return false;

    setIsUpdating(true);
    try {
      const { error } = await supabase
        .from("restaurants")
        .update({
          service_tax_percentage: percentage,
          service_tax_enabled: enabled,
        })
        .eq("id", activeRestaurant.id);

      if (error) throw error;

      await refetch();
      toast.success("Taxa de serviço atualizada!");
      return true;
    } catch (error) {
      console.error("Error updating service tax:", error);
      toast.error("Erro ao atualizar taxa de serviço");
      return false;
    } finally {
      setIsUpdating(false);
    }
  };

  const calculateServiceTax = useCallback(
    (subtotal: number): number => {
      if (!serviceTaxEnabled) return 0;
      return (subtotal * serviceTaxPercentage) / 100;
    },
    [serviceTaxEnabled, serviceTaxPercentage]
  );

  return {
    serviceTaxPercentage,
    serviceTaxEnabled,
    updateServiceTax,
    calculateServiceTax,
    isUpdating,
  };
}
